import UmlPackageShape from '../../Types/UmlPackageShape.js';
import UmlClassShape from '../../Types/UmlClassShape.js';
import UmlCommentShape from '../../Types/UmlCommentShape.js';
import UmlIconShape from '../../Types/UmlIconShape.js';

export const MAP_WIDTH = 200;
export const MAP_HEIGHT = 140;
export const MAP_PADDING = 8;
export const MIN_SHAPE_PX = 2;

/**
 * Computes the world-space bounding box of a flat list of top-level shapes.
 * Nested package children live inside their parent's own x/y/w/h (absolute
 * world coords, see UmlCanvasEngine.translateChildren), so top-level bounds
 * are a good-enough approximation for v1 — no need to walk the tree.
 * @param {object[]} shapes
 * @returns {{minX:number, minY:number, width:number, height:number}|null}
 */
export function computeBounds(shapes) {
    if (shapes.length === 0) return null;

    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    shapes.forEach(function expandBounds(shape) {
        minX = Math.min(minX, shape.x);
        minY = Math.min(minY, shape.y);
        maxX = Math.max(maxX, shape.x + shape.w);
        maxY = Math.max(maxY, shape.y + shape.h);
    });

    return { minX, minY, width: Math.max(maxX - minX, 1), height: Math.max(maxY - minY, 1) };
}

// Distinct muted color per shape-type, purely for the minimap legend — no relation
// to the real canvas colors (those come from each widget's own CSS).
export function colorForShape(shape) {
    if (shape instanceof UmlPackageShape) return '#4a8abf';
    if (shape instanceof UmlClassShape) return '#5fb87a';
    if (shape instanceof UmlCommentShape) return '#d1b34a';
    if (shape instanceof UmlIconShape) return '#b06fd1';
    return '#888888';
}

// Hover-label (JxHint, not JxTooltip — see JxHint.jsx class-comment: documentation-style
// hint, no auto-hide) — name + shape.kind, so it doubles as a quick sanity-check: a shape
// that visually sits inside a package on the real canvas but shows up here as a loose
// top-level dot (not nested) is worth checking for a missing parentId.
export function labelForShape(shape) {
    const name = shape.caption?.text || shape.name || '(no name)';
    return `${name} \u2014 ${shape.kind || 'shape'}`;
}
